import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import TitleImage from '../components/shs/TitleImage/TitleImage';
import Quotes from '../components/shs/Quotes/Quotes';
import TiledCards from '../components/experiences/TiledCards/TiledCards';
import ShsTestimonials from '../components/shs/ShsTestimonials/ShsTestimonials';
import queryString from 'query-string';
import { getAndSetCampaignDetails } from '../util/ApiUtil';
import analyticsContext from '../components/analytics/Analytics';
import partnerStyles from '../config/partnerStylesConfig';

class ShsExperiences extends Component {
  sendReportingEventOnLoad() {
    analyticsContext.withAdvancedProps({ section: 'homeScreen' }).screenEvent();
  }
  componentDidMount() {
    window.scroll(0, 0);
    const queryData = queryString.parse(window.location.search);
    window.messageId = queryData && queryData.messageId;
    if (window.messageId) {
      getAndSetCampaignDetails(window.messageId, this.sendReportingEventOnLoad);
    } // if user did not land through a campaign
    else {
      this.sendReportingEventOnLoad();
    }
  }
  render() {
    return (
      <div className="ShsExperiencesContainer">
        <TitleImage
          img={partnerStyles.experiencesHomeTitleImage}
          title={this.props.experiencesTitle}
          subtitle={'Get smart about your home'}
        />
        <TiledCards />
        <Quotes />
        <ShsTestimonials />
      </div>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => ({
  experiencesTitle: state.experiences.experiencesList && state.experiences.experiencesList.experiencesTitle,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ShsExperiences));



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/ShsExperiences.js